<template>
  <div>
    <v-data-table
      :headers="reviewDataTableHeaders"
      :items="reviewItems"
      class="elevation-1 my-5 mx-5"
      :search="searchReviewItems"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchReviewItems"
            append-icon="mdi-magnify"
            :label="$t('quotation_item_new_install_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            color="primary"
            class="ml-5"
            v-if="isRoleManagerOrAdmin"
            :disabled="editedApplyFormStatus !== status.Pending"
            @click="isShowReviewDialog = true"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowReviewDialog" persistent max-width="600px">
            <v-card>
              <v-card-title>{{ $t('common_new') }}</v-card-title>
              <v-card-text>
                <ValidationObserver ref="dialogEditedReviewForm">
                  <v-row>
                    <v-col>
                      <ValidationProvider name="簽核人" rules="required" v-slot="{ errors }">
                        <v-autocomplete
                          :items="userList"
                          v-model="editedReviewForm.ReviewBy"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          item-text="UserName"
                          item-value="UserName"
                          :loading="isLoadingUser"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            簽核人
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeReviewDialog">
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="success" text @click="saveReviewForm">{{ $t('common_save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isLoadingDeleteReview"
            :isLoadingSaveBtn="isLoadingDeleteReview"
            :isShowDeleteDialog="isShowDeleteReviewDialog"
            :deleteMessage="'common_delete'"
            @closeDelete="closeDeleteReviewDialog"
            @confirmDelete="confirmDeleteReview"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        {{ convertInstallPositionStatus(item.Status) }}
      </template>
      <template v-slot:[`item.ReviewTime`]="{ item }">
        {{ convertToDateTimeFormat(item.ReviewTime) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          icon
          small
          @click="isShowReviewDialogBtn(item)"
          v-if="isRoleManagerOrAdmin"
          :disabled="item.Status !== status.Pending"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          icon
          small
          @click="isShowDeleteReviewDialogBtn(item)"
          v-if="isRoleManagerOrAdmin"
          :disabled="item.Status !== status.Pending || reviewItems.length === 1"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpReviewApplicationForm, HttpUser } from '@/js/http-Manager'
import { InstallPositionStatus } from '@/js/InstallPositionStatus'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { mapGetters } from 'vuex'
export default {
  components: { DeleteDialog },
  props: {
    tab: {
      type: String
    },
    editedApplyFormNumber: {
      type: String
    },
    editedApplyFormStatus: {
      type: Number
    }
  },
  name: 'ReviewForm',
  data: () => ({
    status: InstallPositionStatus,
    reviewItems: [],
    searchReviewItems: '',
    isShowReviewDialog: false,
    editedReviewForm: {
      Number: '',
      RejectedReason: '',
      Status: 0,
      ReviewBy: '',
      ReviewTime: 0
    },
    defaultReviewForm: {
      Number: '',
      RejectedReason: '',
      Status: 0,
      ReviewBy: '',
      ReviewTime: 0
    },
    editedReviewFormIndex: -1,
    isShowDeleteReviewDialog: false,
    isLoadingDeleteReview: false,
    userList: [],
    isLoadingUser: false
  }),
  async mounted () {
    await this.getReviewList()
    await this.getUser()
  },
  watch: {
    async tab (val) {
      if (val === 'tab-2') {
        await this.getReviewList()
      }
    }
  },
  computed: {
    ...mapGetters('login', {
      isRoleManagerOrAdmin: 'isRoleManagerOrAdmin'
    }),
    reviewDataTableHeaders () {
      return [
        { text: '簽核人', value: 'ReviewBy' },
        { text: '簽核時間', value: 'ReviewTime' },
        { text: '狀態', value: 'Status' },
        { text: '拒絕原因', value: 'RejectedReason' },
        { text: this.$t('common_edit'), value: 'Edit' }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return ''
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    convertInstallPositionStatus (val) {
      return InstallPositionStatus.InstallPositionStatusName(val)
    },
    async getReviewList () {
      let response = await HttpReviewApplicationForm.GetAllReviewApplicationForm({
        number: this.editedApplyFormNumber
      })
      this.reviewItems = response.status === 200 ? response.data.Data : []
    },
    isShowReviewDialogBtn (item) {
      this.editedReviewFormIndex = this.reviewItems.indexOf(item)
      this.editedReviewForm = JSON.parse(JSON.stringify(item))
      this.isShowReviewDialog = true
    },
    closeReviewDialog () {
      this.isShowReviewDialog = false
      this.editedReviewFormIndex = -1
      this.editedReviewForm = JSON.parse(JSON.stringify(this.defaultReviewForm))
    },
    async saveReviewForm () {
      let isExist =
        this.reviewItems.findIndex(
          (item) =>
            item.ReviewBy === this.editedReviewForm.ReviewBy && item.Id !== this.editedReviewForm.Id
        ) !== -1
      if (isExist) {
        alert('簽核人已存在')
      } else {
        const isValid = await this.$refs.dialogEditedReviewForm.validate()
        if (isValid) {
          if (this.editedReviewFormIndex === -1) {
            this.editedReviewForm.Number = this.editedApplyFormNumber
            this.editedReviewForm.Status = this.status.Pending
            await HttpReviewApplicationForm.AddReviewApplicationForm(this.editedReviewForm)
          } else {
            await HttpReviewApplicationForm.UpdateReviewApplicationForm(this.editedReviewForm)
          }
          await this.getReviewList()
          this.$emit('getReviewApplicationForm')
          this.$emit('getInstallPositionApplyList')
          this.$emit('searchInstallPositionApplyForm')
          this.closeReviewDialog()
        }
      }
    },
    isShowDeleteReviewDialogBtn (item) {
      this.editedReviewFormIndex = this.reviewItems.indexOf(item)
      this.isShowDeleteReviewDialog = true
    },
    closeDeleteReviewDialog () {
      this.isShowDeleteReviewDialog = false
      this.editedReviewFormIndex = -1
    },
    async confirmDeleteReview () {
      this.isLoadingDeleteReview = true
      await HttpReviewApplicationForm.DeleteReviewApplicationForm(
        this.reviewItems[this.editedReviewFormIndex].Id
      )
      this.isLoadingDeleteReview = false
      await this.getReviewList()
      this.$emit('getReviewApplicationForm')
      this.$emit('getInstallPositionApplyList')
      this.$emit('searchInstallPositionApplyForm')
      this.closeDeleteReviewDialog()
    },
    async getUser () {
      this.isLoadingUser = true
      let response = await HttpUser.GetUsers()
      this.isLoadingUser = false
      this.userList = response.status === 200 ? response.data.Data : []
      var index = 0
      for (var element of this.userList) {
        if (element.UserName === 'God') {
          this.userList.splice(index, 1)
          break
        }
        index++
      }
    }
  }
}
</script>
